import React from 'react';

import "./styles.scss";

export const Background = ({children}) => {
    return (
        <div className="main-background-user">
            {children}
        </div>
    )
};
